// @filename: EventBus.ts
import Vue from 'vue';
/**
 * Utilizzato per la gestione di eventi, l'oggetto può emettere
 * eventi utilizzando la funzion `$emit(event-name: string, params?: any)`
 * può essere utilizzanta come ascoltatore utilizzando la funzione `$on(event-name: string, callback: function)`
 */
export const EventBus = new Vue();
